export const ONE_TRUST_STRICTLY_NECESSARY_GROUP = 'C0001';
export const ONE_TRUST_PERFORMANCE_GROUP = 'C0002';
export const ONE_TRUST_FUNCTIONAL_GROUP = 'C0003';
export const ONE_TRUST_TARGETING_GROUP = 'C0004';
